import { useUpdateObjectiveResultsMutation } from '../../../__generated__/graphql';
import { useUserInfo } from '../../../context/UserInfo';

export const useUpdateObjectiveResults = () => {
  const { id: meId } = useUserInfo();

  return useUpdateObjectiveResultsMutation({
    update: (cache, response) => {
      if (response.errors || !response.data) {
        return;
      }
      const managerId = cache.identify({
        __typename: 'Manager',
        Id: meId,
      });
      cache.evict({
        id: managerId,
        fieldName: 'employeesObjectiveAchievements',
      });
      cache.gc();
    },
  });
};
